import classNames from 'classnames';
import { Button } from 'devextreme-react/button';
import { ScrollView } from 'devextreme-react/scroll-view';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import { useScreenSize } from '../../../utils/media-query';
import { useAppSelector, useAppDispatch } from '../../../contexts/hooks';
import { setPanelPined, setPanelVisible } from '../../../contexts/slices/orders';
import { ReactNode, useEffect, useRef, useState } from 'react';

export const PanelDetails = ({ children }: { children?: ReactNode }) => {
  const dispatch = useAppDispatch();
  const { PanelVisible, PanelPined } = useAppSelector((x) => x.globalOrders);
  const contenedorRef = useRef<HTMLDivElement>(null);
  const [localPanelVisible, setLocalPanelVisible] = useState(PanelVisible);
  const handlePined = () => {
    dispatch(setPanelPined(!PanelPined));
  };

  const { isLarge, isMedium } = useScreenSize();

  useEffect(() => {
    setLocalPanelVisible(PanelVisible);
  }, [PanelVisible]);

  useEffect(() => {
    if (isLarge || isMedium) {
      setLocalPanelVisible(PanelVisible);
      return;
    }
    setLocalPanelVisible(false);
    dispatch(setPanelVisible(false));
  }, []);

  const handleClickOutside = (event: MouseEvent) => {
    if (localPanelVisible && !PanelPined) {
      if (contenedorRef.current && !contenedorRef.current.contains(event.target as Node)) {
        handlePanelClose();
      }
    }
  };

  useEffect(() => {
    if (localPanelVisible && !PanelPined) {
      document.addEventListener('click', handleClickOutside);
    } else {
      document.removeEventListener('click', handleClickOutside);
    }
    // Limpia el evento cuando el componente se desmonta
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [localPanelVisible, PanelPined]);

  const handlePanelClose = () => {
    if (!PanelPined) {
      document.removeEventListener('click', handleClickOutside);
      dispatch(setPanelVisible(false));
    }
  };

  const handlePanelCloseInSide = () => {
    document.removeEventListener('click', handleClickOutside);
    dispatch(setPanelVisible(false));
  };

  return (
    <div id='contact-panel' ref={contenedorRef} className={classNames({ panel: true, open: localPanelVisible, pin: PanelPined && (isLarge || isMedium), unpin: !PanelPined })}>
      <div className='data-wrapper'>
        <Toolbar className='panel-toolbar'>
          <ToolbarItem location='before'>
            <span className='contact-name value'>Elementos</span>
          </ToolbarItem>
          <ToolbarItem location='after' visible={isLarge || isMedium}>
            <Button icon={PanelPined ? 'pin' : 'unpin'} onClick={handlePined} />
          </ToolbarItem>
          <ToolbarItem location='after'>
            <Button icon='close' onClick={handlePanelCloseInSide} />
          </ToolbarItem>
        </Toolbar>
        <ScrollView className='panel-scroll'>{children}</ScrollView>
      </div>
    </div>
  );
};
